import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm, change, untouch } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import * as configs from "./config";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    restrict: "",
    type: "",
    reason: "",
  };

  componentDidMount() {}

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandlerCountry = (event) => {
    this.setState({ restrict: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandlerType = (event) => {
    this.setState({ type: event.value, restrict: "" }, () => {
      this.props.dispatch(change("add_blocklist_form", "restrict", null));
      this.props.dispatch(untouch("add_blocklist_form", "restrict"));
      // this.props.handleForm(this.state);
    });
  };

  printInput = (input) => {
    if (input.key === "type") {
      return (
        <Field
          name={input.key}
          component={renderSelectField}
          options={configs.types}
          onChange={this.formConnectionHandlerType}
        />
      );
    } else if (input.key === "restrict" && this.state.type === "country") {
      return (
        <Field
          name={input.key}
          component={renderSelectField}
          options={this.props.countries}
          onChange={this.formConnectionHandlerCountry}
        />
      );
    } else {
      return (
        <Field
          name={input.key}
          component="input"
          type="text"
          placeholder={input.name}
          onKeyUp={this.formChangeHandler}
        />
      );
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          className="form form--horizontal"
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          {configs.columnHeader.map((input) =>
            !input.system ? (
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {input.name}
                  &nbsp;{input.required ? "*" : ""}
                </span>
                <div className="form__form-group-field">
                  {this.printInput(input)}
                </div>
              </div>
            ) : (
              ""
            )
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "add_blocklist_form", // a unique identifier for this form
})(HorizontalForm);
